import { api } from '@/services/api/client';
import type {
  ChangePasswordRequest,
  ChangePasswordResponse,
  Session,
  TeamMemberSessions,
} from './types';

/**
 * The signed-in person's own account: password and sessions, plus - for a lab
 * owner - the team's sessions.
 *
 * Nothing names whose account: the server takes it from the token, and the
 * team routes answer 403 to anyone who is not the lab's owner.
 */
export const accountService = {
  changePassword(body: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    return api.post<ChangePasswordResponse>('/auth/password', body);
  },

  sessions(signal?: AbortSignal): Promise<Session[]> {
    return api.get<Session[]>('/auth/sessions', signal ? { signal } : {});
  },

  endSession(sessionId: string): Promise<{ status: 'revoked' }> {
    return api.delete<{ status: 'revoked' }>(`/auth/sessions/${sessionId}`);
  },

  /** Every other device; this browser stays signed in. */
  endOtherSessions(): Promise<{ revoked: number }> {
    return api.post<{ revoked: number }>('/auth/sessions/revoke-others');
  },

  teamSessions(signal?: AbortSignal): Promise<TeamMemberSessions[]> {
    return api.get<TeamMemberSessions[]>('/team/sessions', signal ? { signal } : {});
  },

  endTeamSession(sessionId: string): Promise<{ status: 'revoked' }> {
    return api.delete<{ status: 'revoked' }>(`/team/sessions/${sessionId}`);
  },

  endMemberSessions(portalUserId: string): Promise<{ revoked: number }> {
    return api.post<{ revoked: number }>(`/team/members/${portalUserId}/sessions/revoke`);
  },
};
